import React from 'react';
import GenericDialog from "@common/GenericDialog";
import axios from "axios";

const RemoveUserFromSchoolDialog = ({ visible, user, handleClose }) => {

    const removeUserFromSchool = async (userId) => {
        try {
            await axios.post(`/web/ui/sc/removeFromSchool`, userId);
            return true;
        } catch (error) {
            console.error('Error adding user to class:', error);
            displayToastMessage('Failed to remove user from school. Try to remove the user again.', null, 'error', undefined, 10000);
            return false;
        }
    };

    const handleRemoveUser = async () => {
        const success = await removeUserFromSchool([user.userId]);
        if (success) {
            displayToastMessage(`${user.fullName} removed from school.`, null, 'success', undefined, 10000);
            handleClose(true);
        }
    }

    return (
        <GenericDialog
            title={`Remove user from school`}
            open={visible}
            dialogWidth={600}
            onClose={handleClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' }
                },
                {
                    name: 'Remove User',
                    callback: handleRemoveUser,
                    extraProps: {
                        type: 'primary'
                    }
                }
            ]}
        >
            <p>User accounts removed from the school will no longer appear in your school list and will be removed from all classes.</p>
            <br/>
            <p>Are you sure you want to remove <strong>{user?.fullName} - {user?.email}</strong> from your school?</p>
        </GenericDialog>
    );
};

export default RemoveUserFromSchoolDialog;